import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";

// English only for now. Adding a language needs more than a JSON file, see docs/i18n.md.
i18n.use(initReactI18next).init({
  resources: { en: { translation: en } },
  lng: "en",
  fallbackLng: "en",
  // React already escapes text it renders.
  interpolation: { escapeValue: false },
});

export default i18n;
